module.exports = __webpack_public_path__ + "static/media/57.a718a2a5.jpg";